<template>
  <div class="menu-item">
    <div class="meta">
      <h3 class="title">
        {{ item.name }}
        <span class="price" v-if="item.price">
          ({{ item.price }})
        </span>
      </h3>


      <p class="additional-info" v-if="item.info && isTakeaway">
        {{ item.info }}
      </p>

      <div class="additional-info eat-in-menu" v-html="item.info" v-if="item.info && !isTakeaway">

      </div>

      <p class="ingredients" v-if="item.ingredients">
        {{ item.ingredients }}
      </p>
    </div>

    <div class="quantity-actions" v-if="showActions && !completed && isOpenForOrders">
      <button @click.prevent="basketAction(item, 'remove')" class="quantity-action" href="#">
        –
      </button>
        <span class="quantity">{{ item.quantity || 0}}</span>

      <button @click.prevent="basketAction(item, 'add')" class="quantity-action plus" href="#">
        +
      </button>
    </div>
  </div>
</template>

<script>
  import IconPlus from 'icons/plus.svg';
  import IconMinus from 'icons/minus.svg';
  import { mapState, mapGetters } from 'vuex';

  export default {
    name: 'MenuItem',
    components: { IconPlus, IconMinus },
    props: {
      item: {
        type: Object,
        default: null
      },
      completed: {
        type: Boolean,
        default: false
      },
      showActions: {
        type: Boolean,
        default: true
      },
      isTakeaway: {
        type: Boolean,
        default: true
      }
    },

    computed: {
      ...mapState(['order']),
      ...mapGetters('order', ['isOpenForOrders'])
    },

    methods: {
      basketAction (item, action) {
        this.$store.dispatch('order/updateBasket', { id: item.id, action });
      }
    }
  };
</script>

<style lang="stylus" scoped>
  @require '~global/colors'
  @require '~global/typo'
  @require '~global/helpers'

  .menu-item
    width: 100%
    display: flex
    position: relative
    text-align: left
    margin: 0

  .title
    text-transform: uppercase

  .quantity
    color: $black

  .meta
    margin-right: 1rem

  .quantity-actions
    display: flex
    align-items: center
    justify-content: center
    color: $black
    margin-left: auto
    border: 1px solid
    flex-shrink: 0
    align-self: center

  .quantity-action
    background-color: transparent
    padding: 1.2rem .6rem
    border: 0
    line-height: 0
    color: $black
    margin: 0

  .quantity-action.plus
    position: relative
    top: 1px

  .quantity-action:hover
    color: $red
    cursor: pointer

  .eat-in-menu
    >>> p:first-of-type
      margin-bottom: 1rem

  @media (max-width: 320px)
    .quantity-action
      padding: .6rem .8rem
</style>
